import {
  ActivityItemProps,
  ActivityListProps,
} from "../interfaces/ActivityInterface";
import Link from "next/link";
import styles from "../../styles/activityComponent.module.scss";
import LazyImage from "../components/LazyImage";

export default function ActivityItem({
  activity,
  className,
  setActivityDetail,
}: {
  activity: ActivityItemProps;
  className?: string;
  setActivityDetail: (toggleStatus: number, id: string) => void;
}) {
  return (
    <div className={`${styles.popular_activity_block} ${className}`}>
      <Link href={`/party/all/${encodeURIComponent(activity.id)}`}>
        <div className={styles.translucent_bg}> </div>
      </Link>
      <LazyImage
        src="https://i.ibb.co/m6wkznM/image-15-2.png"
        className={styles.images_momo}
        alt="None"
      />
      <div
        className={styles.info_detail}
        onClick={() => setActivityDetail(0, activity.id)}
      >
        <div className={styles.info_circle}> </div>
      </div>
      <div className={styles.activity_details}>
        <div id={styles.catagory}>
          <p>{activity.category}</p>
        </div>
        <h3>{activity.name}</h3>
        <div id={styles.announce}>
          <p>{activity.announce} </p>
        </div>
      </div>
    </div>
  );
}
